var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CommonHeader',{attrs:{"page":'Liste des articles'}}),_c('b-container',{staticStyle:{"padding-top":"20px"},attrs:{"fluid":""}},[_c('ProductsTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }